import { IIndexSignature } from '@selfserve/react-utils';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { stringify, parse } from 'qs';

interface IConfig {
  replace?: boolean | undefined;
  state?: any;
}

type QueryType = IIndexSignature<string | string[]>;

export const useCustomSearchParams = (): [
  QueryType,
  (
    value: QueryType | ((value: QueryType) => QueryType),
    config?: IConfig
  ) => void
] => {
  const [query, setQuery] = useSearchParams();
  const queryObject = useMemo(
    () => parse(query.toString()) as QueryType,
    [query]
  );

  const setQueryObject = useCallback(
    (
      newQuery: QueryType | ((value: QueryType) => QueryType),
      config?: IConfig
    ) => {
      if (typeof newQuery === 'function') {
        setQuery(
          stringify(newQuery(queryObject), {
            arrayFormat: 'brackets',
            encode: false,
          }),
          config || {}
        );
      } else {
        setQuery(
          stringify(newQuery, { arrayFormat: 'brackets', encode: false }),
          config || {}
        );
      }
    },
    [queryObject, setQuery]
  );

  return [queryObject, setQueryObject];
};
